import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'TERRITORY_UPDATE',
    smsDelete : 'TERRITORY_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,
    state : {
        territory: [],
        territory_pg: [],
        territoryLoading: false,
        territoryError: false,
        submitSuccess: false,


        //Route
        route: [],
        route_pg: [],
        routeLoading: false,
        routeError: false,


        //Section
        section: [],
        section_pg: [],
        sectionLoading: false,
        sectionError: false,

        //Office
        office: [],
        office_pg: [],
        officeLoading: false,
        officeError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_TERRITORY (state, item) {
            state.territory = item;
        },

        SET_TERRITORY_WITH_PAGINATION (state, item) {
            state.territory_pg = item;
        },
        TERRITORY_LOADING (state, loading) {
            state.territoryLoading = loading;
        },

        TERRITORY_ERROR (state, hasError) {
            state.territoryError = hasError;
        },

        // Route
        SET_ROUTE(state, item) {
            state.route = item;
        },

        SET_ROUTE_WITH_PAGINATION(state, item) {
            state.route_pg = item;
        },

        ROUTE_LOADING(state, loading) {
            state.routeLoading = loading;
        },

        ROUTE_ERROR(state, hasError) {
            state.routeError = hasError;
        },

        //Section

        SET_SECTION(state, item) {
            state.section = item;
        },

        SET_SECTION_WITH_PAGINATION(state, item) {
            state.section_pg = item;
        },

        SECTION_LOADING(state, loading) {
            state.sectionLoading = loading;
        },

        SECTION_ERROR(state, hasError) {
            state.sectionError = hasError;
        },

        //Office
        SET_OFFICE(state, item) {
            state.office = item;
        },

        SET_OFFICE_WITH_PAGINATION(state, item) {
            state.office_pg = item;
        },

        OFFICE_LOADING(state, loading) {
            state.officeLoading = loading;
        },

        OFFICE_ERROR(state, hasError) {
            state.officeError = hasError;
        },



        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },

    actions: {

        //  Territory
        async updateTerritory ({commit, state, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.patch(V1API.edit_territory + payload.item.id + '/', payload.item , config).then(result=>{
                let data = result.data
                return data
            })
            dispatch('fetchTerritory')
            // dispatch('fetchItemWithPagination', {currentPage:payload.page, perPage:payload.perPage, search_term:payload.search_term});
            return response
        },

        async deleteTerritory ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.delete_territory + payload.item + '/', config).then(result=>{
                let data = result.data
                return data
            })
            dispatch('fetchTerritory')
            // dispatch('fetchItemWithPagination', {currentPage:payload.page, perPage:payload.perPage, search_term:payload.search_term});
            return response
        },

        async fetchTerritoryWithPagination ({ commit }, payload) {
            commit('TERRITORY_LOADING', true);
            commit('TERRITORY_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search_term) params.append('search_term', payload.search_term);
               
                let url = V1API.get_item_with_pagination + '?' + params.toString();
                let result = await axios.get(url, config);
                let response = result.data
                commit('SET_TERRITORY_WITH_PAGINATION', response.results);
                return response

            } catch(error) {
                commit('TERRITORY_ERROR', true);
            } finally {
                commit('TERRITORY_LOADING', false);
            }
        },

        async fetchTerritory ({ commit }) {
            commit('TERRITORY_LOADING', true);
            commit('TERRITORY_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.get_territory, config);
                let response = result.data

                commit('SET_TERRITORY', response.data);
                return response

            } catch(error) {
                commit('TERRITORY_ERROR', true);
            }
            finally {
                commit('TERRITORY_LOADING', false);
            }
        },

        async addTerritory ({commit, dispatch}, payload) {
            commit('TERRITORY_LOADING', true);
            commit('TERRITORY_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.add_territory, payload.item, config).then(result=>{
                    let data = result.data
                    return data
                });
                dispatch('fetchTerritory')
                // dispatch ('fetchItemWithPagination', {currentPage:payload.page, perPage:payload.perPage, search_term:payload.search_term})
                return response

            }catch (e) {
                commit('TERRITORY_ERROR', true);
            }finally {
                commit('TERRITORY_LOADING', false);
            }
        },


        // Route
        async fetchRoute({ commit }) {
            commit('ROUTE_LOADING', true);
            commit('ROUTE_ERROR', false);

            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                const result = await axios.get(V1API.get_route, config);
                const response = result.data;

                commit('SET_ROUTE', response.data);
                return response;

            } catch (error) {
                commit('ROUTE_ERROR', true);
            } finally {
                commit('ROUTE_LOADING', false);
            }
        },

        async fetchRouteWithPagination({ commit }, payload) {
            commit('ROUTE_LOADING', true);
            commit('ROUTE_ERROR', false);

            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();

                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search_term) params.append('search_term', payload.search_term);

                const url = V1API.get_route_with_pagination + '?' + params.toString();
                const result = await axios.get(url, config);
                const response = result.data;

                commit('SET_ROUTE_WITH_PAGINATION', response.results);
                return response;

            } catch (error) {
                commit('ROUTE_ERROR', true);
            } finally {
                commit('ROUTE_LOADING', false);
            }
        },

        async addRoute({ commit, dispatch }, payload) {
            commit('ROUTE_LOADING', true);
            commit('ROUTE_ERROR', false);

            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                const result = await axios.post(V1API.add_route, payload.item, config);
                const response = result.data;

                dispatch('fetchRoute');
                return response;

            } catch (e) {
                commit('ROUTE_ERROR', true);
            } finally {
                commit('ROUTE_LOADING', false);
            }
        },

        async updateRoute({ dispatch }, payload) {
            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            const result = await axios.patch(
                V1API.edit_route + payload.item.id + '/',
                payload.item,
                config
            );

            dispatch('fetchRoute');
            return result.data;
        },

        async deleteRoute({ dispatch }, payload) {
            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            const result = await axios.delete(
                V1API.delete_route + payload.item + '/',
                config
            );

            dispatch('fetchRoute');
            return result.data;
        },


        //Section
          async fetchSection({ commit }) {
            commit('SECTION_LOADING', true);
            commit('SECTION_ERROR', false);

            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                const result = await axios.get(V1API.get_section, config);
                const response = result.data;

                commit('SET_SECTION', response.data);
                return response;

            } catch (error) {
                commit('SECTION_ERROR', true);
            } finally {
                commit('SECTION_LOADING', false);
            }
        },

        async fetchSectionWithPagination({ commit }, payload) {
            commit('SECTION_LOADING', true);
            commit('SECTION_ERROR', false);

            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();

                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search_term) params.append('search_term', payload.search_term);

                const url = V1API.get_section_with_pagination + '?' + params.toString();
                const result = await axios.get(url, config);
                const response = result.data;

                commit('SET_SECTION_WITH_PAGINATION', response.results);
                return response;

            } catch (error) {
                commit('SECTION_ERROR', true);
            } finally {
                commit('SECTION_LOADING', false);
            }
        },

        async addSection({ commit, dispatch }, payload) {
            commit('SECTION_LOADING', true);
            commit('SECTION_ERROR', false);

            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                const result = await axios.post(V1API.add_section, payload.item, config);
                const response = result.data;

                dispatch('fetchSection');
                return response;

            } catch (e) {
                commit('SECTION_ERROR', true);
            } finally {
                commit('SECTION_LOADING', false);
            }
        },

        async updateSection({ dispatch }, payload) {
            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            const result = await axios.patch(
                V1API.edit_section + payload.item.id + '/',
                payload.item,
                config
            );

            dispatch('fetchSection');
            return result.data;
        },

        async deleteSection({ dispatch }, payload) {
            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            const result = await axios.delete(
                V1API.delete_section + payload.item + '/',
                config
            );

            dispatch('fetchSection');
            return result.data;
        },

        //Office
          async fetchOffice({ commit }) {
            commit('OFFICE_LOADING', true);
            commit('OFFICE_ERROR', false);

            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                const result = await axios.get(V1API.get_office, config);
                const response = result.data;

                commit('SET_OFFICE', response.data);
                return response;

            } catch (error) {
                commit('OFFICE_ERROR', true);
            } finally {
                commit('OFFICE_LOADING', false);
            }
        },

        async fetchOfficeWithPagination({ commit }, payload) {
            commit('OFFICE_LOADING', true);
            commit('OFFICE_ERROR', false);

            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();

                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search_term) params.append('search_term', payload.search_term);

                const url = V1API.get_office_with_pagination + '?' + params.toString();
                const result = await axios.get(url, config);
                const response = result.data;

                commit('SET_OFFICE_WITH_PAGINATION', response.results);
                return response;

            } catch (error) {
                commit('OFFICE_ERROR', true);
            } finally {
                commit('OFFICE_LOADING', false);
            }
        },

        async addOffice({ commit, dispatch }, payload) {
            commit('OFFICE_LOADING', true);
            commit('OFFICE_ERROR', false);

            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                const result = await axios.post(V1API.add_office, payload.item, config);
                const response = result.data;

                dispatch('fetchOffice');
                return response;

            } catch (e) {
                commit('OFFICE_ERROR', true);
            } finally {
                commit('OFFICE_LOADING', false);
            }
        },

        async updateOffice({ dispatch }, payload) {
            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            const result = await axios.patch(
                V1API.edit_office + payload.item.id + '/',
                payload.item,
                config
            );

            dispatch('fetchOffice');
            return result.data;
        },

        async deleteOffice({ dispatch }, payload) {
            const config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            const result = await axios.delete(
                V1API.delete_office + payload.item + '/',
                config
            );

            dispatch('fetchOffice');
            return result.data;
        }



    },



    getters: {}
}
